import React, { Component } from 'react';
import { Modal, Button, Table, Tabs } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

const TabPane = Tabs.TabPane;
const tabConfig = [
    {
        title: '合同附件',
        key: 'contractappend',
    },
    {
        title: '合同关闭支持性文件',
        key: 'jdeCloseOtherSupport',
    },
]

class LookAttachment extends Component {
    state = {
        visible: false,
        rowKey: null,
        activeKey: 'contractappend',
    }
    
    show = (record, rowKey) => {
        this.setState({
            record,
            rowKey,
            visible: true
        }, () => {
            this.loadData();
        });
    };

    close = () => {
        this.setState({ visible: false });
    };

    loadData = () => {
        const {  record:{investigationJdeContractId, investigationId}, activeKey, rowKey } = this.state;
        const data = {};
        if(rowKey == 'mainInvestigationJdeContractCode') {
            data.investigationId = investigationId;
            data.investigationJdeContractId = investigationJdeContractId;
            data.type = 'invCloseOtherSupportFile';
        }else {
            data.investigationJdeContractId = investigationJdeContractId;
            data.type = activeKey;
        }
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeCodeEnclosure,
            data: {
                ...data
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ data: res.data });
            }
        }
        $.sendRequest(options);
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60,
    }, {
        title: '附件名称',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
            const { id, name } = record;
            return <a onClick={e => this.downLoadFile(e, id)}>{name}</a>
        }
    }]

    getDateSource = () => {
        const { data = [] } = this.state;
        const dataSource = [];

        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
                name: item.name
            })
        });

        return dataSource;
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey },this.loadData);
    }

    render () {
        const { record = {}, visible, activeKey, rowKey } = this.state;
        return (
            <Modal
                title="查看附件"
                visible={visible}
                onCancel={this.close}
                width="520px"
                footer={<Button type="primary" onClick={this.close}>关 闭</Button>}
            >
                <div>
                    {
                        rowKey == 'investigationJdeContractCode' ? 
                            <div style={{ marginBottom: 10 }}>JDE项目号：{record[rowKey]}</div>
                        :
                            <div style={{ marginBottom: 10 }}>JDE主项目号：{record[rowKey]}</div>
                    }
                    {
                        rowKey == 'investigationJdeContractCode' && 
                        <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                            {tabConfig.map(el => <TabPane tab={el.title} key={el.key}></TabPane>)}
                        </Tabs>
                    }
                    
                    <Table
                        columns={this.getColumns()}
                        dataSource={this.getDateSource()}
                        rowKey={record => record.index}
                        pagination={false}
                    />
                </div>
            </Modal>
        );
    }
}

export default LookAttachment;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/LookAttachment.js